angular.module('impactx.imageUpload').directive('appImageUpload', ['TranslationService', function(TranslationService) {
    return {
        scope: {
            image: '=',
            imageReadonly: '=?',
            trns: '=?',
            defaultImage: "@?"
        },
        controller: 'ImageUploadCtrl',
        restrict: 'E',
        templateUrl: 'shared/imageUpload/templates/image-upload.tmpl.html',
    };
}]);